const INITIAL_STATE = {
  data: {},
  errors: {},
        
}
const updateFiledAlert = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'UPDATE_FIELD_ALERT_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'UPDATE_FIELD_ALERT_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
        
export default updateFiledAlert;